<template>
  <b-form 
    :class="[inputClass, customizedClass]"
    class="no-loading-scroll"
    ref="offcanvas"
    v-bind="$attrs"
    v-if="isShow"
    @submit.prevent="formSubmitted"
  >
    <div 
      :class="`offcanvas offcanvas-${position} show`" 
      tabindex="-1" aria-labelledby="offcanvasTopLabel"
      :style="computedWidth"
    >
      <div v-if="!hideHeader" class="modal-header">
        <h5 class="modal-title" v-if="title && !titleHtml">{{ title }}</h5>
        <h5 v-if="titleHtml" v-html="titleHtml" class="modal-title" />
        <button type="button" aria-label="Close" class="close btn2 btn2-tertiary btn-lg" @click="hide()">  <i class="uil-times"></i></button>
      </div>

      <div v-if="bodyMessage">
        <p>{{ bodyMessage }}</p>
      </div>

      <div
        class="d-flex  pt-2"
        style="overflow-x: hidden; overflow-y: auto"
        :class="{
          'flex-column': !buttonTop,
          'flex-column-reverse': buttonTop,
        }"
      >
        <div 
          class="px-4" 
        >
          <component
            v-if="component"
            :is="computedComponent"
            :parameters="parameters"
            ref="component"
            @onClick="$emit('onClick', $event)"
          />
          
          <slot v-else name="custom-component"></slot>

        </div>
      </div>
      <div
        class="d-flex justify-content-end modal-bottom pr-4 pb-3"
        :class="{
          'mb-3': buttonTop,
          [`${btnContainerClass}`]: btnContainerClass
        }"
        v-if="computedButtons"
      >

        <Button
          v-if="!!noText"
          :loading="loading"
          :label="noText"
          :class="noBtnClass"
          class="btn px-4 py-1"
          @click="hide()" 
        />
        <Button
          v-if="!!yesText"
          :loading="loading"
          :label="yesText"
          :class="yesBtnClass"
          :disabled="buttonDisable"
          class="btn px-4 py-2 ml-1"
          @click="onClickYes()"
        />
      </div>
    </div>
  </b-form>
</template>

<script>
import DialogMixins from '@mixins/dialog'
import Button from '@components/buttons'

export default {
  mixins: [ DialogMixins ],
  components: {
    Button,
  },
  props: {
    component: [ Object, Function ],
    parameters: {
      type: Object,
      default: () => {}
    },
    yesText: String,
    noText: String,
    buttonDisable: {
      type: Boolean,
      default: false
    },
    buttonTop: {
      type: Boolean,
      default: false
    },
    title: String,
    position: {
      type: String,
      default: 'end'
    },
    bodyMessage: String,
    hideHeader: {
      type: Boolean,
      default: false
    },
    btnContainerClass: String,
    width: {
      type: String,
      default: '600'
    },
    size: String,
    loading: {
      type: Boolean,
      default: false
    },
    yesBtnClass: {
      type: String,
      default: "btn2 btn2-primary btn2-md"
    },
    noBtnClass: {
      type: String,
      default: "btn2 btn2-secondary btn2-md"
    },
    titleHtml: String,
    customizedClass: {
      type: String,
      default: 'custom-overlay'
    },
    inputClass:String,
    customBtnClass: String,
  },
  computed: {
    computedButtons () {
      return !!this.yesText || !!this.noText
    },
    computedComponent () {
      return this.component
    },
    computedWidth () {
      let width = this.width
      
      if(this.size) {
        switch (this.size) {
          case 'xl':
            width = '1200'
            break;
          case 'lg':
            width = '600'
            break;
          case 'md':
            width = '300'
            break;
        }
      }
      return `width: ${width}px;`
    },
    computedClass () {
      return 'w-100'// + this.customBtnClass
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    show() {
      // this.$refs.offcanvas.show()
      this.isShow = true
    },
    hide() {
      // this.$refs.offcanvas.hide()
      this.isShow = false
      
      if (this.component) {
        if (this.is_reset_model) {
          this.resetModel(this.$refs.component)
        }
        if (this.autoload) {
          this.reload(this.$refs.component)
        }
      }
      this.$emit('onClose')
    },
    onClickYes() {
      if (this.component) {
        this.$emit('onYes', this.$refs.component)
      }
      else this.$emit('onYes')
    },
    formSubmitted() {
      if (this.component) {
        this.$emit('onSubmit', this.$refs.component)
      }
      else this.$emit('onSubmit')
    }
  },
} 
</script>